define(function(require,exports,module){

    var regexColor = /(\d+),/g;
    var regexAlpha= /([\d\.]+)(\))/;
    var regexNoAlpha = /[^\(]+\(([^\)]+).*/;
    var colors = {
        white     : 'rgba(255, 255, 255, 1)',
        transparent: "rgba(255, 255, 255, 0)",
        text: "rgba(255, 255, 255, 1)",
        shadow: 'rgba(0, 0, 0, 1)',
        borderDark: 'rgba(0, 0, 0, 0.32)'
    };
    var returnWHITE = function() {
        return colors.white;
    };
    var defaultColor = {
        getPitchColor : returnWHITE,
        getPitchBallColor : returnWHITE
    };

    var COLOR_BALL_KEY = 'ballColorBall';
    var COLOR_INPLAY_KEY = 'ballColorInPlay';
    var COLOR_INPLAY_OUTS_KEY = 'ballColorInPlayOuts';
    var COLOR_STRIKE_KEY = 'ballColorStrike';

    function colorShift($0, $1) {
        var shifted = +$1 - 40;
        return (shifted > 0 ? shifted : 0 ) + ',';
    }

    function colorGradShift($0, $1) {
        var shifted = +$1 - 120;
        return (shifted > 0 ? shifted : 0 ) + ',';
    }

    function colorShiftLight($0, $1) {
        var shifted = +$1 + 40;
        return (shifted < 255 ? shifted : 255 ) + ',';
    }

    function noAlpha($0, $1) {
        return "rgb(" + $1.split(',').slice(0, 3).join(',') + ")";
    }

    function alphaShift($0, $1, $2) {
        return ((+$1 - 0.1) + $2);
    }

    function extractBallColorByType(pitch, config) {
        var ballColorKey;

        switch(true) {
            case pitch.isBall:
               ballColorKey = COLOR_BALL_KEY;
            break;
            case pitch.isStrike:
               ballColorKey = COLOR_STRIKE_KEY;
            break;
            case pitch.isInPlay:
               ballColorKey = COLOR_INPLAY_KEY;
               // If it's in play out(s), and we have a different color defined
               // use that.  Otherwise, it's the same as all inPlay
               if ((pitch.code === 'X' || pitch.code === 'Y') && config[COLOR_INPLAY_OUTS_KEY]) {
                   ballColorKey = COLOR_INPLAY_OUTS_KEY;
               }
            break;
        }
        var ballColor = (config && config[ballColorKey]) || pitch.details.ballColor || pitch.pitch.getPitchBallColor && pitch.pitch.getPitchBallColor() || colors.white;

        return ballColor;
    }

    function PitchShader(pitch,renderer) {
        if(!pitch || (pitch && !pitch.isPitch)){
            pitch=defaultColor;
        }

        this.renderer=renderer;
        var scalers = renderer.scalers;
        var ballColor = extractBallColorByType(pitch, scalers);
        var trailColor = pitch.details.trailColor || pitch.pitch.getPitchColor && pitch.pitch.getPitchColor() || colors.white;

        this.pitch = pitch;
        this.fill=trailColor;
        this.ball=ballColor;
        this.pathStroke=this.fill;
        this.ballStroke=scalers.ballStrokeColor;
        this.text=scalers.ballTextColor || colors.text;
        this.shadow=colors.shadow;
        this.gradientStart=this.fill.replace(regexColor,colorGradShift);
        this.gradientStop=this.fill;
    }

    PitchShader.prototype = {

        getColor : function() {
            return this.fill;
        },
        getBallColor : function() {
            return this.ballColor;
        },
        getGradient  : function(xStart,yStart,xEnd,yEnd) {
            var scalers = this.renderer.scalers;
            var gradientStart = this.gradientStart;
            var gradientStop = this.gradientStop;

            if(this.renderer.isCanvas && this.renderer.gtx_bg) {

                var radius= (Math.max(xEnd, yEnd) - scalers.fakeBallSize) * 0.5 / scalers.canvasDensity,
                    grad=this.renderer.gtx_bg.createRadialGradient(xStart, yStart, 0, xEnd, yEnd, radius);

                grad.addColorStop(0, gradientStart);
                grad.addColorStop(0.25, gradientStop);

                return grad;
            }
            if(this.renderer.isVector) {
                var radius = (Math.max(xEnd, yEnd) - scalers.fakeBallSize) * 0.5;
                var grad = document.createElement("radialGradient");
                var stop1 = document.createElement("stop");
                var stop2 = document.createElement("stop");

                grad.setAttribute("id","pitch-grad-"+this.pitch.num);
                grad.setAttribute("data-grad-radius",radius);
                stop1.setAttribute("offset","0");
                stop1.setAttribut("stop-color", gradientStart);
                stop2.setAttribute("offset","25%");
                stop2.setAttribut("stop-color", gradientStop);

                grad.appendChild(stop1);
                grad.appendChild(stop2);
                return grad;
            }
            return this.fill;
        },
        alphaShift : function(color) {
            return color.replace(regexAlpha,alphaShift);
        }
    }
    return PitchShader;
});
